import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import { Dropdown, Input, Menu, Tag } from 'antd';
import { apiHolder, apis } from 'api';
import { ContactActions, MailActions, MailTemplateActions, TempContactActions, useActions, useAppSelector } from '@web-common/state/createStore';
import ContactChip from './contact-chip';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { extractEmailsFromText, getCopiedContact, getCopiedContacts } from './helper';
import { WriteContext } from '@web-setting/Mail/components/CustomTemplate/template_add_modal';
import { buildContactItem, transMailContactModel2ContactItem } from '@web-common/utils/contact_util';
import { doGetMailContactModelByContactItem } from '@web-common/state/selector/contact';
import { copyText, paste, isSupportPaste } from '@web-common/components/UI/ContextMenu/util';
import { getIn18Text } from 'api';
import { useSelectorContext } from './SelectorContext';
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const ContactTag = props => {
    var _a;
    const { value, label, onClose, type, sendMailConflictConfig, itemIndex, isLast, setInputOrder, refSelect, setContactCardVisible, clickShowContactCard, setLastItemPos, } = props;
    const { isMailTemplate } = useContext(WriteContext);
    const { selectedItems, selectedEmails, selectedEmailsSet } = useSelectorContext();
    const item = (_a = label === null || label === void 0 ? void 0 : label.props) === null || _a === void 0 ? void 0 : _a.item;
    const [inputValue, setInputValue] = useState('');
    const [inputWidth, setInputWidth] = useState(40);
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const measureRef = useRef(null);
    const inContactBook = item.type !== 'external';
    const contactName = item.name || '';
    const accountEmail = item.email;
    const email = inContactBook ? `${contactName}<${accountEmail}>` : accountEmail;
    const selectedEmailsCount = useAppSelector(state => {
        const emails = isMailTemplate ? state.tempContactReducer.selectedTags.emails : state.contactReducer.selectedTags.emails;
        return emails.length;
    });
    const receivers = useAppSelector(state => { var _a, _b, _c, _d; return (isMailTemplate ? (_b = (_a = state.mailTemplateReducer) === null || _a === void 0 ? void 0 : _a.mailTemplateContent) === null || _b === void 0 ? void 0 : _b.receiver : (_d = (_c = state.mailReducer) === null || _c === void 0 ? void 0 : _c.currentMail) === null || _d === void 0 ? void 0 : _d.receiver); });
    const onActions = isMailTemplate ? MailTemplateActions : MailActions;
    const { doModifyReceiver } = useActions(onActions);
    const onContactActions = isMailTemplate ? TempContactActions : ContactActions;
    const { doSelectTags } = useActions(onContactActions);
    useLayoutEffect(() => {
        var _a;
        setInputWidth((((_a = measureRef === null || measureRef === void 0 ? void 0 : measureRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 40) + 10);
    }, [inputValue]);
    const isMultiSelect = selectedEmailsCount > 0;
    const onDblClick = (e) => {
        e.stopPropagation();
        setEditing(true);
        setInputValue(email);
        setTimeout(() => {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setInputValue(email);
        }, 50);
    };
    const handleModifyTag = async () => {
        var _a;
        let _inputValue = ((_a = inputValue === null || inputValue === void 0 ? void 0 : inputValue.split(/<|>/)) === null || _a === void 0 ? void 0 : _a.filter(item => item.includes('@'))[0]) || '';
        _inputValue = _inputValue.trim();
        if (_inputValue === accountEmail) {
            setEditing(false);
            return;
        }
        const reply = selectedItems.has(_inputValue);
        if (_inputValue === '' || reply) {
            selectedItems.delete(accountEmail);
        }
        else {
            const result = await mailApi.getContractItemByEmail([_inputValue], 'to');
            let curContactItem;
            if (result === null || result === void 0 ? void 0 : result.length) {
                curContactItem = result.map(transMailContactModel2ContactItem)[0];
            }
            else {
                curContactItem = buildContactItem({ email: _inputValue, name: _inputValue, type, item: _inputValue });
            }
            selectedItems.set(accountEmail, curContactItem);
        }
        const list = [...selectedItems.values()];
        const receiver = await doGetMailContactModelByContactItem(list, type);
        doModifyReceiver({
            receiver,
            receiverType: type,
        });
        setEditing(false);
    };
    const onMultiTagDel = () => {
        doModifyReceiver({ receiver: selectedEmails, receiverType: type, operation: 'delete' });
        doSelectTags({ emails: [], type });
    };
    const onTagCopy = async () => {
        if (!(await isSupportPaste())) {
            SiriusModal.error({
                content: '浏览器版本过低，不支持联系人的复制/剪切，请升级到新版chrome浏览器使用',
                okText: getIn18Text('ZHIDAOLE'),
                hideCancel: true,
            });
            return true;
        }
        const copiedContacts = getCopiedContacts(receivers, type, selectedEmails);
        const data = isMultiSelect ? copiedContacts : getCopiedContact(item);
        copyText(data);
        return false;
    };
    const onTagDelete = isMultiSelect ? onMultiTagDel : onClose;
    const onTagCut = async () => {
        if (await onTagCopy())
            return;
        onTagDelete();
    };
    const onTagPaste = async () => {
        if (!(await isSupportPaste())) {
            SiriusModal.error({
                content: '您的浏览器版本过低，请使用键盘快捷键（Ctrl+V）。或升级到新版chrome浏览器使用',
                okText: getIn18Text('ZHIDAOLE'),
                hideCancel: true,
            });
            return;
        }
        const clipboardData = await paste(false);
        if (!clipboardData)
            return;
        const extractEmails = extractEmailsFromText(clipboardData);
        const result = await contactApi.doGetContactByEmails(extractEmails, type);
        const target = result.map(transMailContactModel2ContactItem);
        const contactItemList = receivers.filter(_ => _.mailMemberType === type).map(transMailContactModel2ContactItem);
        const index = contactItemList.findIndex(c => selectedEmailsSet.has(c.email));
        if (index !== -1) {
            contactItemList.splice(index, 1, ...target);
        }
        const receiver = await doGetMailContactModelByContactItem(contactItemList, type);
        doModifyReceiver({
            receiver,
            receiverType: type,
        });
    };
    const onContextMenu = (e) => {
        e.stopPropagation();
        doSelectTags({
            emails: [accountEmail],
            type,
        });
    };
    const contextMenu = (React.createElement(Menu, null,
        React.createElement(Menu.Item, { onClick: onTagCopy }, getIn18Text('FUZHI')),
        React.createElement(Menu.Item, { onClick: onTagCut }, getIn18Text('JIANQIE')),
        React.createElement(Menu.Item, { onClick: onTagPaste }, getIn18Text('ZHANTIE'))));
    return (React.createElement("div", { onContextMenu: onContextMenu },
        React.createElement(Dropdown, { overlay: contextMenu, trigger: ['contextMenu'] },
            React.createElement(Tag, { onClose: onClose, onClick: e => e.stopPropagation() },
                React.createElement("div", { hidden: !editing, style: { width: inputWidth + 40 } },
                    React.createElement(Input, { size: "small", style: { boxShadow: 'none', border: '1px solid transparent' }, value: inputValue, onChange: e => setInputValue(e.target.value), onBlur: handleModifyTag, onPressEnter: () => { var _a; return (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.blur(); }, ref: inputRef, onMouseDown: e => e.stopPropagation(), onKeyDown: e => e.stopPropagation() }),
                    React.createElement("span", { style: { visibility: 'hidden' }, ref: measureRef, "aria-hidden": true },
                        inputValue,
                        "\u00A0")),
                !editing && (React.createElement(ContactChip, { onDoubleClick: onDblClick, type: type, value: value, item: item, itemIndex: itemIndex, isLast: isLast, setInputOrder: setInputOrder, setLastItemPos: setLastItemPos, setContactCardVisible: setContactCardVisible, clickShowContactCard: clickShowContactCard, refSelect: refSelect, sendMailConflictConfig: sendMailConflictConfig }))))));
};
export default ContactTag;
